import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (!localStorage.getItem("cookie_consent")) {
      this.element.hidden = false
    }
  }

  accept() {
    localStorage.setItem("cookie_consent", "accepted")
    this.element.remove()
  }

  decline() {
    localStorage.setItem("cookie_consent", "declined")
    this.element.remove()
  }
}
